import { get } from './api';

export const getRoles = async () => {
  // Return static roles
  return {
    success: true,
    data: [
      { role_id: 1, name: 'admin', permissions: [] },
      { role_id: 2, name: 'pharmacist', permissions: [] },
      { role_id: 3, name: 'customer', permissions: [] },
      { role_id: 4, name: 'delivery', permissions: [] },
    ],
  };
};

export const getPermissions = () => get('/permissions');
